import { palette } from 'assets/styles/colors';
import colors from '../colors';

const defaultTextColor = colors.palette.primary.main;
const labelColor = palette.neutral[100];

const autocomplete = {
  MuiAutocomplete: {
    styleOverrides: {
      option: {
        borderBottom: '1px solid rgba(61, 95, 116, 0.2)',
        backgroundColor: labelColor,
      },
      noOptions: {
        color: defaultTextColor,
      },
      listbox: {
        padding: 0,
      },
      paper: {
        backgroundColor: labelColor,
        padding: 0,
        width: '100%',
        margin: 0,
        borderRadius: 0,
        boxShadow: 'none',
      },
    },
  },
};

export default autocomplete;
